import { Injectable } from '@angular/core';
import {AppConfig} from "../app.config";
import {Http} from "@angular/http";
import {BaseService} from "./BaseService";

@Injectable()
export class HospitalBranchesService  extends  BaseService {

  constructor(private http: Http, private config: AppConfig) {
    super();

    }

   getAll() {
    return this.http.get(this.config.apiUrl + '/hospital_branches/', this.jwt(true))
       .map(res => res.json());
  }

  getById(_id) {
    return this.http.get(this.config.apiUrl + '/hospital_branches/' + _id+'/', this.jwt(true))
       .map(res => res.json());
  }

  getHospitalBranches(_id) {
    return this.http.get(this.config.apiUrl + '/hospitals/' + _id+'/branches/', this.jwt(true))
       .map(res => res.json());
  }

  create(doctor) {
    return this.http.post(this.config.apiUrl + '/hospital_branches/', doctor, this.jwt(true));
  }

  update(doctor) {
    return this.http.put(this.config.apiUrl + '/hospital_branches/' + doctor._id, doctor, this.jwt(true));
  }

  delete(_id) {
    return this.http.delete(this.config.apiUrl + '/hospital_branches/' + _id+'/', this.jwt(true));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/hospital-branches.service.ts